<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiArrowUp } from "@mdi/js"

export default {
  name: "ArrowUpIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiArrowUp,
    }
  }
}
</script>
